import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { MessageIcon } from '@/components/common/icons/message';
import Badge from '@/components/ui/badge';
import { useUnreadChatsQuery } from '@/features/message/hooks/use-unread-chats-query';
import { useOffersRequestsQuery } from '@/features/offers/hooks/use-offers-query';
import { useStoreOffersRequestsQuery } from '@/features/offers/hooks/use-store-offers-query';
import { useStoreTailoringRequestsQuery } from '@/features/tailoring-requests/hooks/use-store-tailoring-query';
import { useTailoringRequestsQuery } from '@/features/tailoring-requests/hooks/use-tailoring-query';
import { cn } from '@/lib/cn';
export const MessagesAction = () => {
  const pathname = usePathname();
  const {
    data: userTailoring
  } = useTailoringRequestsQuery();
  const {
    data: storeTailoring
  } = useStoreTailoringRequestsQuery();
  const {
    data: userOffers
  } = useOffersRequestsQuery();
  const {
    data: storeOffers
  } = useStoreOffersRequestsQuery();
  const {
    data: unreadChats
  } = useUnreadChatsQuery();
  const userTailoringLength = userTailoring?.length || 0;
  const storeTailoringLength = storeTailoring?.length || 0;
  const userOffersLength = userOffers?.length || 0;
  const storeOffersLength = storeOffers?.length || 0;
  const unreadChatsLength = unreadChats?.length || 0;
  const notificationLength = userTailoringLength + storeTailoringLength + userOffersLength + storeOffersLength + unreadChatsLength;
  const isActive = pathname.startsWith('/messages');
  return <div className="mr-2.5 ml-1 relative" data-sentry-component="MessagesAction" data-sentry-source-file="messages.tsx">
      <Link href={'/messages'} data-sentry-element="Link" data-sentry-source-file="messages.tsx">
        <MessageIcon className={cn('w-6 h-6', {
        'text-primary': isActive
      })} data-sentry-element="MessageIcon" data-sentry-source-file="messages.tsx" />
        {notificationLength > 0 && <div className="absolute -top-2.5 -right-2.5">
            <Badge body={notificationLength} />
          </div>}
      </Link>
      <span className="sr-only">items in cart, view cart</span>
    </div>;
};